import { Currency } from '@futrli-sdk/currencies';
import { ExtendedCurrency } from './types';
import { sortBy } from 'lodash';

/**
 * Transforms input words so all words start with capital letter
 * @param input text to be transformed
 * @returns Transformed input: Australian dollar -> Australian Dollar
 */
export const capitalizeWords = (input: string) => input.replace(/\b\w/g, (char: string) => char.toUpperCase());

/**
 * Takes the list of currencies and returns an extended list, which is sorted
 * alphabetically but also with favourites at the top
 * @param currencies - list of currencies to process
 */
export const getExtendedAndSortedCurrencies = (currencies: Currency[]) => {
  const favouriteCodes = ['GBP', 'EUR', 'AUD', 'NZD', 'USD', 'CAD'];
  const extendedCurrencies: ExtendedCurrency[] = currencies.map(currency => ({
    ...currency,
    displayName: `${currency.code} - ${capitalizeWords(currency.currency)}`
  }));
  const sortedExtendedCurrencies = sortBy(extendedCurrencies, 'displayName');
  const output: ExtendedCurrency[] = [];

  // Add favourites first
  for (const code of favouriteCodes) {
    const c = sortedExtendedCurrencies.find(ec => ec.code === code);
    if (c) {
      output.push(c);
    }
  }

  // Add divider
  output.push({
    code: '-',
    currency: '-',
    displayName: '--------------------------------'
  });

  // Add anything else in alphabetical order after our favourites
  for (const currency of sortedExtendedCurrencies) {
    if (!favouriteCodes.includes(currency.code)) {
      output.push(currency);
    }
  }

  return output;
};
